import calls from '@/backend/api-calls'

const state = () => ({
  tickets: [],
  companies: [],
  contacts: [],
  categories: [],
  ticketPagination: {
    page: 1,
    pages: 1
  },
  ticketsSelected: [],
  companyPagination: {
    page: 1,
    pages: 1
  },
  companiesSelected: [],
  contactPagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
}

// actions
const actions = {
  getTickets: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.ticketingTickets.get(parameters)
        .then(resp => {
          commit("setTickets", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addTicket: ({commit}, {data, parameters}) => {
    return new Promise((resolve, reject) => {
      calls.ticketingTickets.post(data, parameters)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Ticket successfully added'
            },
            { root: true }
          );
          commit("insertTicket", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateTicket: ({commit}, { ticketId, data, notify }) => {
    return new Promise((resolve, reject) => {
      calls.ticketingTicket.put(ticketId, data)
        .then(resp => {
          if (notify) {
            commit(
              'app/setNotification',
              { 
                status: true, 
                type: 'success',
                message: 'Changes successfully saved'
              },
              { root: true }
            );
          }
          commit("insertUpdatedTicket", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteTicket: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      calls.ticketingTicket.delete(id)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Ticket successfully deleted'
            },
            { root: true }
          );
          commit("removeTicket", id);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  attachImage: ({commit}, { ticketId, data }) => {
    return new Promise((resolve, reject) => {
      calls.ticketingTicket.attachImage(ticketId, data)
        .then(resp => {
          commit("insertUpdatedTicket", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getCompanies: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCompanies.get(parameters)
        .then(resp => {
          commit("setCompanies", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addCompany: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCompanies.post(data)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Company successfully added'
            },
            { root: true }
          );
          commit("insertCompany", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateCompany: ({commit}, { companyId, data }) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCompany.put(companyId, data)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Company information successfully updated'
            },
            { root: true }
          );
          commit("insertUpdatedCompany", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteCompany: ({commit}, companyId) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCompany.delete(companyId)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Company successfully deleted'
            },
            { root: true }
          );
          commit("removeCompany", companyId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getContacts: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.ticketingContacts.get(parameters)
        .then(resp => {
          commit("setContacts", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addContact: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.ticketingContacts.post(data)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Contact successfully added'
            },
            { root: true }
          );
          commit("insertContact", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateContact: ({commit}, { contactId, data }) => {
    return new Promise((resolve, reject) => {
      calls.ticketingContact.put(contactId, data)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Contact information successfully updated'
            },
            { root: true }
          );
          commit("insertUpdatedContact", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteContact: ({commit}, contactId) => {
    return new Promise((resolve, reject) => {
      calls.ticketingContact.delete(contactId)
        .then(resp => {
          commit(
            'app/setNotification',
            { 
              status: true, 
              type: 'success',
              message: 'Contact successfully deleted'
            },
            { root: true }
          );
          commit("removeContact", contactId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  getCategories: ({commit}, parameters) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCategories.get(parameters)
        .then(resp => {
          commit("setCategories", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addCategory: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCategories.post(data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully added'
            }, { root: true }
          );
          commit("insertCategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateCategory: ({commit}, { categoryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCategory.put(categoryId, data)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully updated'
            }, { root: true }
          );
          commit("insertUpdatedCategory", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteCategory: ({commit}, categoryId) => {
    return new Promise((resolve, reject) => {
      calls.ticketingCategory.delete(categoryId)
        .then(resp => {
          commit(
            'app/setNotification', 
            { 
              status: true, 
              type: 'success',
              message: 'Category successfully deleted'
            }, { root: true }
          );
          commit("removeCategory", categoryId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setTickets (state, data) {
    state.tickets = data.results;
    state.ticketPagination = data.pagination;
  },
  insertTicket (state, data) {
    state.tickets.push(data);
  },
  insertUpdatedTicket (state, data) {
    state.tickets.forEach((ticket, i) => {
      if (ticket.id == data.id) {
        state.tickets.splice(i, 1);
        state.tickets.push(data);
      }
    })
  },
  removeTicket (state, ticketId) {
    state.tickets.forEach((ticket, i) => {
      if (ticket.id == ticketId) {
        state.tickets.splice(i, 1);
      }
    })
  },
  changeTicketPage(state, page) {
    state.ticketPagination.page = page;
  },
  setCompanies (state, data) {
    state.companies = data.results;
    state.companyPagination = data.pagination;
  },
  insertCompany (state, data) {
    state.companies.push(data);
  },
  insertUpdatedCompany (state, data) {
    let companyIds = state.companies.map(d => d.id);
    if (companyIds.indexOf(data.id) == -1) {
      state.companies.push(data);
    } else {
      state.companies.forEach((company, i) => {
        if (company.id == data.id) {
          state.companies.splice(i, 1);
          state.companies.push(data);
        }
      })
    }
  },
  removeCompany (state, companyId) {
    state.companies.forEach((company, i) => {
      if (company.id == companyId) {
        state.companies.splice(i, 1);
      }
    })
  },
  changeCompanyPage(state, page) {
    state.companyPagination.page = page;
  },
  setContacts (state, data) {
    state.contacts = data.results;
    state.contactPagination = data.pagination;
  },
  insertContact (state, data) {
    state.contacts.push(data);
  },
  insertUpdatedContact (state, data) {
    let contactIds = state.contacts.map(d => d.id);
    if (contactIds.indexOf(data.id) == -1) {
      state.contacts.push(data);
    } else {
      state.contacts.forEach((contact, i) => {
        if (contact.id == data.id) {
          state.contacts.splice(i, 1);
          state.contacts.push(data);
        }
      })
    }
  },
  removeContact (state, contactId) {
    state.contacts.forEach((contact, i) => {
      if (contact.id == contactId) {
        state.contacts.splice(i, 1);
      }
    })
  },
  changeContactPage(state, page) {
    state.contactPagination.page = page;
  },
  setCategories: (state, data) => {
    state.categories = data;
  },
  insertCategory: (state, data) => {
    state.categories.push(data);
  },
  insertUpdatedCategory: (state, data) => {
    state.categories.forEach((category, i) => {
      if (category.id == data.id) {
        state.categories.splice(i, 1, data);
      }
    })
  },
  removeCategory: (state, categoryId) => {
    state.categories.forEach((category, i) => {
      if (category.id == categoryId) {
        state.categories.splice(i);
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}